// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lF5JoC {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.h896wz {
  font-size: var(--type-label-lg-font-size);
  font-weight: var(--type-label-lg-font-weight);
  color: var(--text-neutral-dark);
  margin-bottom: 10px;
}

.YlYDST {
  position: relative;
}

.XMhewn {
  opacity: 0;
  width: 0;
  height: 0;
}

.XMhewn:checked + .qRjmbY {
  background-color: var(--surface-primary-medium);
}

.XMhewn:checked + .qRjmbY .Jzd7cv {
  transform: translateX(var(--spacing-2));
}

.qRjmbY {
  display: inline-block;
  width: var(--spacing-5);
  height: var(--spacing-3);
  background-color: var(--surface-neutral-subtle);
  border-radius: var(--spacing-3);
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s;
}

.Jzd7cv {
  position: absolute;
  top: var(--spacing-0-5);
  left: var(--spacing-0-5);
  width: var(--spacing-2);
  height: var(--spacing-2);
  background-color: var(--surface-neutral-white);
  border-radius: 50%;
  transition: transform 0.3s;
}

.BCUAhL {
  display: flex;
  gap: var(--spacing-3);
  margin-bottom: var(--spacing-2);
}

.Zj495N {
  background-color: transparent !important;
  gap: 8px;
  padding: 0;
  width: auto;
  max-width: auto;
}

.IY0YqB {
  margin-top: var(--spacing-2);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/PayrollDeductionSection/PayrollDeductionSection.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;EAC7C,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,+CAA+C;EAC/C,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,8CAA8C;EAC9C,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,QAAQ;EACR,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".sectionHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.sectionTitle {\n  font-size: var(--type-label-lg-font-size);\n  font-weight: var(--type-label-lg-font-weight);\n  color: var(--text-neutral-dark);\n  margin-bottom: 10px;\n}\n\n.switchContainer {\n  position: relative;\n}\n\n.switchInput {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.switchInput:checked + .switchLabel {\n  background-color: var(--surface-primary-medium);\n}\n\n.switchInput:checked + .switchLabel .switchSlider {\n  transform: translateX(var(--spacing-2));\n}\n\n.switchLabel {\n  display: inline-block;\n  width: var(--spacing-5);\n  height: var(--spacing-3);\n  background-color: var(--surface-neutral-subtle);\n  border-radius: var(--spacing-3);\n  position: relative;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.switchSlider {\n  position: absolute;\n  top: var(--spacing-0-5);\n  left: var(--spacing-0-5);\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n  background-color: var(--surface-neutral-white);\n  border-radius: 50%;\n  transition: transform 0.3s;\n}\n\n.radioGroupDiscount {\n  display: flex;\n  gap: var(--spacing-3);\n  margin-bottom: var(--spacing-2);\n}\n\n.radioItemParams {\n  background-color: transparent !important;\n  gap: 8px;\n  padding: 0;\n  width: auto;\n  max-width: auto;\n}\n\n.checkboxContainer {\n  margin-top: var(--spacing-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionHeader": `lF5JoC`,
	"sectionTitle": `h896wz`,
	"switchContainer": `YlYDST`,
	"switchInput": `XMhewn`,
	"switchLabel": `qRjmbY`,
	"switchSlider": `Jzd7cv`,
	"radioGroupDiscount": `BCUAhL`,
	"radioItemParams": `Zj495N`,
	"checkboxContainer": `IY0YqB`
};
module.exports = ___CSS_LOADER_EXPORT___;
